import { SelectionModel } from "@angular/cdk/collections";
import { Component, OnInit, ViewChild } from "@angular/core";
import { MatDialog, MatTableDataSource } from "@angular/material";
import { LaboratoryTubesSearchItem } from "src/app/model/laboratory-tubes/laboratory-tubes-search-item";
import { PagerControlComponent } from "../../controls/pager/pager-control.component";
import { Router } from "@angular/router";
import { AuthService } from "src/app/services/auth.service";
import { MenuService } from "src/app/services/menu.service";
import {
  IFilterResponse,
  SearchFilter,
} from "src/app/infrastructure/iFilter-component";
import { LaboratoryTubesService } from "src/app/services/laboratory-tubes/laboratory-tubes.service";
import { LaboratoryTubeStatus } from "src/app/model/laboratory-tubes/laboratory-tube-status";
import {
  ObservationDialogComponent,
  ObservationDialogEditResponse,
} from "../../dialogs/observation-dialog/observation-dialog.component";
import { LaboratoryTubesFilterComponent } from "../laboratory-tubes-filter/laboratory-tubes-filter.component";
import { LaboratoryTubeRejectionReasonFilter } from "src/app/model/laboratory-tubes/laboratory-tube-rejection-reason-filter";
import { LaboratoryTubesControlsDialogComponent } from "../laboratory-tubes-controls-dialog/laboratory-tubes-controls-dialog.component";

@Component({
  selector: "app-laboratory-tubes-search",
  templateUrl: "./laboratory-tubes-search.component.html",
  styleUrls: ["./laboratory-tubes-search.component.css"],
})
export class LaboratoryTubesSearchComponent implements OnInit {
  loading: boolean;

  displayedColumns: string[] = [
    "Date",
    "State",
    "PatientDocument",
    "Identification",
    "Star",
  ];

  dataSource = new MatTableDataSource<LaboratoryTubesSearchItem>([]);
  selection = new SelectionModel<LaboratoryTubesSearchItem>(true, []);
  studyReportSearchItem: LaboratoryTubesSearchItem[] = [];
  searchFilters: SearchFilter[];
  rejectionReasons: LaboratoryTubeRejectionReasonFilter[]= [];
  loadingMasiveAction: boolean;
  loadingAction: boolean;


  @ViewChild("searchFilter", { static: false })
  searchFilter: LaboratoryTubesFilterComponent;
  @ViewChild("pager", { static: true }) pager: PagerControlComponent;

  constructor(
    public dialog: MatDialog,
    private router: Router,
    private menuService: MenuService,
    private authService: AuthService,
    private laboratoryTubesService: LaboratoryTubesService
  ) {
    this.menuService.setMenuTitle("Muestras derivadas", "Control");
  }

  isAllSelected() {
    if (this.selection.selected && this.pager.getAllItems()) {
      const numSelected = this.selection.selected.length;
      const numRows = this.pager.getAllItems().length;
      return numSelected === numRows;
    } else {
      return false;
    }
  }

  masterToggle() {
    this.isAllSelected()
      ? this.selection.clear()
      : this.pager.getAllItems().forEach((row) => this.selection.select(row));
  }

  selectedPageIndexChange(pagedItems: any[]) {
    this.dataSource = new MatTableDataSource(pagedItems);
    this.loading = false;
  }

  onEndSearch(response: IFilterResponse<LaboratoryTubesSearchItem>) {
    this.loadingMasiveAction = false;
    this.studyReportSearchItem = response.items;
    this.searchFilters = response.searchFilters;
    this.selection = new SelectionModel<LaboratoryTubesSearchItem>(true, []);
    this.pager.setItems(this.studyReportSearchItem);
  }

  onStartSearch() {
    this.loading = true;
  }

  async setAcepted() {
    if (this.selection.selected.length > 0) {
      const dialogRef = this.dialog.open(ObservationDialogComponent, {
        width: "50%",
        data: {
          text: "",
          textMenu: "Observaciones",
          noRequired: true,
        },
      });

      dialogRef
        .afterClosed()
        .subscribe(async (response: ObservationDialogEditResponse) => {
          if (response) {
            this.loadingMasiveAction = true;
            const ids = this.selection.selected.map((x) => x.Id);
            await this.laboratoryTubesService.changeStatus(
              ids,
              LaboratoryTubeStatus.Aceptado,
              response.text
            );

            await this.searchFilter.search();
          }
        });
    }
  }

  async setRejected() {
    if (this.selection.selected.length > 0) {
      const dialogRef = this.dialog.open(ObservationDialogComponent, {
        width: "50%",
        data: {
          text: "",
          textMenu: "Observaciones",
          noRequired: true,
          filterText: "Motivo de rechazo",
          filterItems: this.rejectionReasons
        },
      });

      dialogRef
        .afterClosed()
        .subscribe(async (response: ObservationDialogEditResponse) => {
          if (response) {
            this.loadingMasiveAction = true;
            const ids = this.selection.selected.map((x) => x.Id);
            await this.laboratoryTubesService.changeStatus(
              ids,
              LaboratoryTubeStatus.Rechazado,
              response.text,
              response.selectedFilter ? response.selectedFilter.Id : null
            );
            await this.searchFilter.search();
          }
        });
    }
  }

  async revertStatus() {
    if (this.selection.selected.length > 0) {
      const dialogRef = this.dialog.open(ObservationDialogComponent, {
        width: "50%",
        data: {
          text: "",
          textMenu: "Observaciones",
          noRequired: true,
        },
      });

      dialogRef
        .afterClosed()
        .subscribe(async (response: ObservationDialogEditResponse) => {
          if (response) {
            this.loadingMasiveAction = true;
            const ids = this.selection.selected.map((x) => x.Id);
            await this.laboratoryTubesService.revertStatus(ids, response.text);
            await this.searchFilter.search();
          }
        });
    }
  }

  async viewControls(item: LaboratoryTubesSearchItem){
    const details = await this.laboratoryTubesService.getDetails(item.Id);
    const controls = details.Controls;

    if (controls && controls.length > 0) {

      const dialogRef = this.dialog.open(LaboratoryTubesControlsDialogComponent, {
        width: "60%",
        data: controls
      });
    }

  }

  control(item: LaboratoryTubesSearchItem) {
    this.router.navigate(["laboratory-tubes-wizard", item.Id]);
  }

  async ngOnInit() {
    this.rejectionReasons = await this.laboratoryTubesService.getRejectionReasons();
  }
}
